import React, { createContext, useContext } from 'react';
import { useMachine } from '@xstate/react';
import paymentMachine from './payment.machine';

const PaymentContext = createContext(null);

export type PaymentContextHook = {
  paymentState: any;
  sendToPaymentState: Function;
  paymentService: any;
};

interface PaymentProviderProps {
  children: React.ReactNode;
}

const PaymentProvider: React.FC<PaymentProviderProps> = ({
  children,
} : PaymentProviderProps) => {
  const [paymentState, sendToPaymentState, paymentService] = useMachine(paymentMachine);
  return (
    <PaymentContext.Provider value={{ paymentState, sendToPaymentState, paymentService }}>
      { children }
    </PaymentContext.Provider>
  );
};

const usePaymentContext = () : PaymentContextHook => useContext(PaymentContext);

export {
  PaymentContext as default,
  PaymentProvider,
  usePaymentContext,
};
